import Service from "../../service/index";

const Lessons = {
  name: "Courses",
  stateFactory: true,
  namespaced: true,
  state: {
    lessons: [],
    lessonProgress: [],
  },
  mutations: {
    SET_LESSONS: (state, data) => {
      state.lessons = data;
    },
    SET_LESSONS_PROGRESS: (state, data) => {
      state.lessonProgress = data;
    },
  },
  actions: {
    getLessons({ commit }, { lessonId, userId }) {
      return Service.Lessons.onGetLessons(lessonId, userId).then((response) => {
        if (response.code === 200) {
          let response_data = response.result;
          commit("SET_LESSONS", response_data);
          return response;
        }
      });
    },
    saveLessonProgress({ commit }, { model, accessToken }) {
      return Service.Lessons.onSaveLessonProgress(model, accessToken).then(
        (response) => {
          if (response.code === 200) {
            let response_data = response.result;
            commit("SET_LESSONS_PROGRESS", response_data);
            return response;
          }
        }
      );
    },
    saveLessonYouTubeProgress({ commit }, { model, accessToken }) {
      return Service.Lessons.onSaveLessonYouTubeProgress(
        model,
        accessToken
      ).then((response) => {
        if (response.code === 200) {
          let response_data = response.result;
          commit("SET_LESSONS_PROGRESS", response_data);
          return response;
        }
      });
    },
    saveLessonH5pProgress({ commit }, { model, accessToken }) {
      return Service.Lessons.onSaveLessonH5pProgress(
        model,
        accessToken
      ).then((response) => {
        if (response.code === 200) {
          let response_data = response.result;
          commit("SET_LESSONS_PROGRESS", response_data);
          return response;
        }
      });
    },
  },
};

export default Lessons;
